export default "__VITE_PUBLIC_ASSET__ccfcfaa6__"